// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import animateScrollTo from "animated-scroll-to";
import { Typeset, Typepad, PageContainer } from "../Partials/Typeset";
import { ContactInfo } from "../Partials/Ui";
import { sizes, expandValue, breakpoints } from "../../helpers/theme";
var $ = require("jquery");

let GridStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[2])}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${expandValue(sizes.space)};
  }
`;
let GridStyled = styled("div")`
  ${GridStyles}
`;

export class PageContact extends React.Component {
  componentDidMount() {
    const options = {
      // duration of the scroll per 1000px, default 500
      speed: 0,
      // minimum duration of the scroll
      minDuration: 0,
      // maximum duration of the scroll
      maxDuration: 0
    };
    animateScrollTo(0, options);
    $("#Top").addClass("Banished");
  }
  render() {
    return (
      <PageContainer>
        <Helmet>
          <title>Contact - Jesse Stewart | User Interface Designer</title>
          <meta
            itemprop="description"
            content="Contact information for Jesse Stewart in East Lansing, Michigan. a UI/UX Designer & Front-End Developer. "
          />
        </Helmet>
        <Typepad pageTop>
          <Typeset>
            <h1 className="line">Contact</h1>
            <GridStyled>
              <div>
                <ContactInfo em="email" />
              </div>
            </GridStyled>
          </Typeset>
        </Typepad>
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Contact.js